/**
 * <ec-footer-accordion> — footer columns are <details> accordions on mobile
 * and always open from tablet up. Without JS every column stays open.
 */
if (!customElements.get('ec-footer-accordion')) {
  class EcFooterAccordion extends HTMLElement {
    connectedCallback() {
      this.details = Array.from(this.querySelectorAll('[data-ec-footer-details]'));
      this.query = window.matchMedia('(min-width: 768px)');

      this.onSummaryClick = (event) => {
        if (this.query.matches) event.preventDefault();
      };
      this.details.forEach((el) => el.querySelector('summary')?.addEventListener('click', this.onSummaryClick));

      this.sync = () => this.details.forEach((el) => (el.open = this.query.matches));
      this.query.addEventListener('change', this.sync);
      this.sync();
    }

    disconnectedCallback() {
      this.query?.removeEventListener('change', this.sync);
    }
  }

  customElements.define('ec-footer-accordion', EcFooterAccordion);
}
